export const vidnologObl = [
  { name: "ОСН", id: 1 },
  { name: "УСН", id: 2 },
  { name: "Другая", id: 3 },
]
